import { STORY_VERSIONS } from '@monoimin/constants';

import { newStoryblokApi } from './newStoryblokApi';

import { GetStoriesParams } from './types';
import { defineMergedParams } from './defineMergedParams';
import { StoriesCacheOptions } from './getStories';

export const getAll = async <T>(
  slug: string,
  params?: GetStoriesParams,
  cacheOptions?: StoriesCacheOptions
) => {
  const mergedParams = await defineMergedParams(params);

  const { Storyblok } = newStoryblokApi(
    mergedParams.version === STORY_VERSIONS.DRAFT,
    'server',
    cacheOptions?.revalidate
  );

  try {
    const result = await Storyblok.getAll(slug, mergedParams);
    return result as unknown as T;
  } catch (error: any) {
    console.error(`Error fetching ${slug} in getAll function:`, error?.message);
    throw error;
  }
};
